/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserMigrationStatus {
    FirstAccess = 'FirstAccess',
    Postponed = 'Postponed',
    NotRequired = 'NotRequired',
    Completed = 'Completed'
}


export function instanceOfUserMigrationStatus(value: any): boolean {
    for (const key in UserMigrationStatus) {
        if (Object.prototype.hasOwnProperty.call(UserMigrationStatus, key)) {
            if (UserMigrationStatus[key as keyof typeof UserMigrationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserMigrationStatusFromJSON(json: any): UserMigrationStatus {
    return UserMigrationStatusFromJSONTyped(json, false);
}

export function UserMigrationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationStatus {
    return json as UserMigrationStatus;
}

export function UserMigrationStatusToJSON(value?: UserMigrationStatus | null): any {
    return value as any;
}

export function UserMigrationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): UserMigrationStatus {
    return value as UserMigrationStatus;
}

